var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnerFeelingsV1(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.3033 4.6967C18.2322 7.62563 18.2322 12.3744 15.3033 15.3033C12.3743 18.2322 7.62562 18.2322 4.6967 15.3033C1.76777 12.3743 1.76777 7.62562 4.6967 4.6967C7.62563 1.76777 12.3744 1.76777 15.3033 4.6967",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14.1667C11.3892 14.1667 12.5 13.0558 12.5 11.6667H7.5C7.5 13.0558 8.61083 14.1667 10 14.1667V14.1667Z",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08329 7.5V8.33333",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 7.5V8.33333",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerFeelingsV1);
export default __webpack_public_path__ + "static/media/ownerFeelingsV1.daac79ee75f43c3dffffc27fc059124b.svg";
export { ForwardRef as ReactComponent };